import {enableProdMode, isDevMode} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import {RouteReuseStrategy, provideRouter} from '@angular/router';
import {provideAnimations} from '@angular/platform-browser/animations';
import {IonicRouteStrategy, provideIonicAngular} from '@ionic/angular/standalone';

import {DatePipe} from '@angular/common';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideServiceWorker} from '@angular/service-worker';
import {AppComponent} from './app/app.component';
import {routes} from './app/app.routes';
import {errorInterceptor} from './app/core/interceptor/error.interceptor';
import {httpInterceptor} from './app/core/interceptor/http.interceptor';
import {BuildEnquiryLinkPipe} from './app/feature/dealer/enquiry/pipe/build-enquiry-link.pipe';
import {AmPmPipe} from './app/shared/pipes/am-pm.pipe';
import {FilterPipe} from './app/shared/pipes/filter.pipe';
import {RouterActivePipe} from './app/shared/pipes/router-active.pipe';
import {environment} from './environments/environment';
import {IndianCurrencyPipe} from './app/shared/pipes/indian-currency.pipe';

if (environment.production) {
  enableProdMode();
}

// eslint-disable-next-line @typescript-eslint/no-floating-promises
bootstrapApplication(AppComponent, {
  providers: [
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    provideIonicAngular({mode: 'md'}),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([httpInterceptor, errorInterceptor])),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    DatePipe,
    AmPmPipe,
    RouterActivePipe,
    BuildEnquiryLinkPipe,
    FilterPipe,
    IndianCurrencyPipe,
  ],
});
